import _ from 'lodash'
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { getApiPath } from '@/common/api-proxy.js'

/**
 * 交互素材标签列表 http://localhost:8067/?doc=res_store/tag.go
 * @param {{type: string}} params
 */
export function fetchItavResTag(params) {
  return request({
    url: `${v2Host}/res_store/tag/list1`,
    method: 'get',
    params: params
  })
}

/**
 * 非交互素材标签列表 http://localhost:8067/?doc=res_store/tag.go
 * @param {{type: string}} params
 */
export function fetchNonItavResTag(params) {
  return request({
    url: `${v2Host}/res_store/tag/list2`,
    method: 'get',
    params: params
  })
}

export function fetchResTag(params) {
  return request({
    url: `${v2Host}${getApiPath('/res_store/tag/type-tags')}`,
    method: 'get',
    params: params
  })
}

/**
 * 创建标签 http://localhost:8067/?doc=res_store/tag.go#-res_store-tag-create
 * @param {String} params.type
 * @param {String} params.pid
 * @param {String} params.name
 */
export function createTag(params) {
  return request({
    url: `${v2Host}/res_store/tag/create`,
    method: 'post',
    data: params
  })
}
/**
 * 更新标签 http://localhost:8067/?doc=res_store/tag.go#-res_store-tag-update
 * @param {String} data.id
 * @param {String} data.name
 */
export function updateTag(data) {
  const id = data.id
  data = _.omit(data, ['id'])
  return request({
    url: `${v2Host}/res_store/tag/update?id=${id}`,
    method: 'post',
    data: data
  })
}

/**
 * 更新标签 http://localhost:8067/?doc=res_store/tag.go#-res_store-tag-update
 * @param {String} data.id
 * @param {String} data.name
 */
export function deleteTag(data) {
  const id = data.id
  data = _.omit(data, ['id'])
  return request({
    url: `${v2Host}/res_store/tag/delete?id=${id}`,
    method: 'post',
    data: data
  })
}
